import TextField from "../Reusable/TextField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useNavigate } from "react-router-dom";
import TimeField from "../Reusable/TimeField/TimeField";

const ShiftForm = ({ register, errors, watch }: any) => {
  const navigate = useNavigate();
  return (
    <>
      <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Shift Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TimeField
          label="Start Time"
          register={register("start_time")}
          errors={errors?.start_time}
        />

        <TimeField
          label="End Time"
          register={register("end_time")}
          errors={errors?.end_time}
        />
        <TextField
          label={"Description"}
          register={register("description")}
          errors={errors?.description}
        />
      </div>
    </>
  );
};

export default ShiftForm;
